import styled from "styled-components";

export const StadisticsContainer = styled.div`

    padding-top: 10%;
    padding-bottom: 10%;

    @media (min-width: 1026px){
    padding-top: 20%;
  }

    .wrapper {
        
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;

        @media (max-width: 768px){

            margin-top: ${props => props.portrait ? `30% !important` : `5 !important`};;
            flex-direction: column !important;
            align-items: center;
            justify-content: center;
        }
    }

`;

export const DivCounter = styled.div`

    width: 300px;
    background-color: #2222229e;
    color: #fff;
    text-align: center;
    border-radius: 100px;
    font-family: 'Bebas Neue Bold';

    @media(max-width: 768px){
        margin-bottom: 20px;
    }

    .container {
        margin-top: 5%;
    }

    .info-row{

        display: flex;
        display-direction: row;
        justify-content: center;

        .icon {
            width: 10%;
            font-size: 50px;
            margin-bottom: 1.6rem;
        }

        .title-logo {
            width: 50%;
        }
        h1{
            
            font-family: 'Bebas Neue Bold';
            
            @media (max-width: 768px){
                margin-top: 8px;
            }
        }

        h4 {
            width: 100%;
            font-family: 'Bebas Neue Bold';
            font-size: 20px;
            margin-top: -20px;
        }
       
    }
`;